import { createWebHistory, createRouter } from "vue-router";

import EcommercePage from "../pages/Dashboard/EcommercePage.vue";
import ProjectManagementPage from "../pages/Dashboard/ProjectManagementPage.vue";

import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import CompleteRegisterPage from "../pages/Authentication/CompleteRegisterPage.vue";

import LogoutPage from "../pages/LogoutPage.vue";
import ProfilePage from "../pages/Profile/Profile.vue";
import AccountSettingsPage from "../pages/Settings/AccountSettingsPage.vue";
import EditPasswordPage from "../pages/Settings/EditPasswordPage.vue";

import BlackListePage from "../pages/Settings/BlackListePage.vue";

// users
import UsersListPage from "../pages/Users/UsersListPage.vue";
import AddUserPage from "../pages/Users/AddUserPage.vue";
import EditUserPage from "../pages/Users/EditUserPage.vue";
import HistoryUserPage from "../pages/Users/HistoryUserPage.vue";

import ListRequestRibPage from "@/pages/Customers/Demandes/ListRequestRibPage.vue";
import ListRequestPhonePage from "@/pages/Customers/Demandes/ListRequestPhonePage.vue";

import ClaimsListPage from "@/pages/Claims/ClaimsListPage.vue";
import HistoryClaimPage from "@/pages/Claims/HistoryClaimPage.vue";
import AddClaimPage from "@/pages/Claims/AddClaimPage.vue";

import ListPickupPage from "@/pages/PickUp/ListPickupPage.vue";
import EditPickupPage from "@/pages/PickUp/EditPickupPage.vue";
import PickupRequestsPage from "@/pages/PickUp/PickupRequestsPage.vue";

import ColisListePage from "@/pages/Colis/ColisListePage.vue";
import NewColisPage from "@/pages/Colis/NewColisPage.vue";
import EditColisPage from "@/pages/Colis/EditColisPage.vue";
import NewColisListePage from "@/pages/Colis/NewColisListePage.vue";
import ImportColisPage from "@/pages/Colis/ImportColisPage.vue";
import ImportColisStockPage from "@/pages/Colis/ImportColisStockPage.vue";

import ProductListPage from "../pages/Stock/ProductListPage.vue";
import AddProductPage from "../pages/Stock/AddProductPage.vue";
import EditProductPage from "../pages/Stock/EditProductPage.vue";
import StockColisPage from "../pages/Stock/StockColisPage.vue";
import AddColisStockPage from "../pages/Stock/AddColisPage.vue";
import EditColisStockPage from "@/pages/Stock/EditProdColisPage.vue";

import InventoryNoteListePage from "@/pages/Notes/Delivery/ListePage.vue";
import DeliveryAddNotePage from "@/pages/Notes/Delivery/AddNotePage.vue";
import DeliveryEditNotePage from "@/pages/Notes/Delivery/EditNotePage.vue";

import InventoryStockNoteListePage from "@/pages/Notes/StockDelivery/ListePage.vue";
import EditNoteBLStockPage from "@/pages/Notes/StockDelivery/EditNotePage.vue";
import AddNoteBLStockPage from "@/pages/Notes/StockDelivery/AddNotePage.vue";

import ReturnListePage from "@/pages/Notes/Return/Client/ReturnListePage.vue";
import EditReturnPage from "@/pages/Notes/Return/Client/EditReturnPage.vue";

import InvoiceListPage from "@/pages/Invoices/InvoiceListPage.vue";
import VirementListPage from "@/pages/Virements/VirementListPage.vue";

import ApiPage from "@/pages/Settings/DocAPI/ApiPage.vue";
import WebhookPage from "@/pages/Settings/DocAPI/WebhookPage.vue";

import ErrorPage from "../pages/ErrorPage.vue";
import VerificationPage from "@/pages/Settings/verificationDocs/VerificationPage.vue";
import ShopifyPage from "@/pages/Settings/Stores/AddShopifyPage.vue";
import SheetsPage from "@/pages/Settings/Stores/SheetsPage.vue";
import ColisConfirmedPage from "@/pages/Settings/Stores/ColisConfirmedPage.vue";
import ColisErronesPage from "@/pages/Settings/Stores/ColisErronesPage.vue";

const routes = [
  {
    path: "/",
    name: "EcommercePage",
    component: EcommercePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/account-settings",
    name: "AccountSettingsPage",
    component: AccountSettingsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/settings-edit-password",
    name: "EditPasswordPage",
    component: EditPasswordPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/black-list",
    name: "BlackListePage",
    component: BlackListePage,
    meta: { requiresAuth: true, permissions: ["black_list"], staffCodes: ["BLACK_LISTE"] },
  },

  // users — admin always, staff needs GESTION_UTILISATEURS
  {
    path: "/users-list",
    name: "UsersListPage",
    component: UsersListPage,
    meta: { requiresAuth: true, staffCodes: ["GESTION_UTILISATEURS"] },
  },
  {
    path: "/add-user",
    name: "AddUserPage",
    component: AddUserPage,
    meta: { requiresAuth: true, staffCodes: ["GESTION_UTILISATEURS"] },
  },
  {
    path: "/edit-user/:id",
    name: "EditUserPage",
    component: EditUserPage,
    meta: { requiresAuth: true, staffCodes: ["GESTION_UTILISATEURS"] },
  },
  {
    path: "/history-user/:id",
    name: "HistoryUserPage",
    component: HistoryUserPage,
    meta: { requiresAuth: true, staffCodes: ["GESTION_UTILISATEURS"] },
  },

  {
    path: "/phone-requests-list",
    name: "ListRequestPhonePage",
    component: ListRequestPhonePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/rib-requests-list",
    name: "ListRequestRibPage",
    component: ListRequestRibPage,
    meta: { requiresAuth: true },
  },

  // claims
  {
    path: "/claims-list",
    name: "ClaimsListPage",
    component: ClaimsListPage,
    meta: { requiresAuth: true, staffCodes: ["RECLAMATION"] },
  },
  {
    path: "/add-claims",
    name: "AddClaimPage",
    component: AddClaimPage,
    meta: { requiresAuth: true, staffCodes: ["RECLAMATION"] },
  },
  {
    path: "/history-claim/:id",
    name: "HistoryClaimPage",
    component: HistoryClaimPage,
    meta: { requiresAuth: true, staffCodes: ["RECLAMATION"] },
  },

  // pickup
  {
    path: "/pickup-list",
    name: "ListPickupPage",
    component: ListPickupPage,
    meta: { requiresAuth: true, staffCodes: ["RAMASSAGE"] },
  },
  {
    path: "/pickup-note-edit/:id/:refCode",
    name: "EditPickupPage",
    component: EditPickupPage,
    props: true,
    meta: { requiresAuth: true, staffCodes: ["RAMASSAGE"] },
  },
  {
    path: "/requests-pickup-list",
    name: "PickupRequestsPage",
    component: PickupRequestsPage,
    meta: { requiresAuth: true, staffCodes: ["RAMASSAGE"] },
  },

  // colis
  {
    path: "/colis-list",
    name: "ColisListePage",
    component: ColisListePage,
    meta: { requiresAuth: true, permissions: ["Parcels"], staffCodes: ["Parcels"] },
  },
  {
    path: "/add-colis",
    name: "NewColisPage",
    component: NewColisPage,
    meta: { requiresAuth: true, permissions: ["Parcels"], staffCodes: ["Parcels"] },
  },
  {
    path: "/edit-colis/:id/:code",
    name: "EditColisPage",
    component: EditColisPage,
    meta: { requiresAuth: true, permissions: ["Parcels"], staffCodes: ["Parcels"] },
  },
  {
    path: "/new-colis-list",
    name: "NewColisListePage",
    component: NewColisListePage,
    meta: { requiresAuth: true, permissions: ["Parcels"], staffCodes: ["Parcels"] },
  },
  {
    path: "/import-colis",
    name: "ImportColisPage",
    component: ImportColisPage,
    meta: { requiresAuth: true, permissions: ["Import"], staffCodes: ["Import"] },
  },
  {
    path: "/import-colis-stock",
    name: "ImportColisStockPage",
    component: ImportColisStockPage,
    meta: { requiresAuth: true, permissions: ["Import"], staffCodes: ["Import"] },
  },

  // stock
  {
    path: "/products-list",
    name: "ProductListPage",
    component: ProductListPage,
    meta: { requiresAuth: true, permissions: ["stock"], staffCodes: ["STOCK"] },
  },
  {
    path: "/add-product",
    name: "AddProductPage",
    component: AddProductPage,
    meta: { requiresAuth: true, permissions: ["stock"], staffCodes: ["STOCK"] },
  },
  {
    path: "/edit-product/:id",
    name: "EditProductPage",
    component: EditProductPage,
    meta: { requiresAuth: true, permissions: ["stock"], staffCodes: ["STOCK"] },
  },
  {
    path: "/colis-stock-list",
    name: "StockColisPage",
    component: StockColisPage,
    meta: { requiresAuth: true, permissions: ["Parcels"], staffCodes: ["STOCK"] },
  },
  {
    path: "/add-colis-stock",
    name: "AddColisStockPage",
    component: AddColisStockPage,
    meta: { requiresAuth: true, permissions: ["Parcels"], staffCodes: ["STOCK"] },
  },
  {
    path: "/edit-colis-stock/:id",
    name: "EditColisStockPage",
    component: EditColisStockPage,
    meta: { requiresAuth: true, permissions: ["Parcels"], staffCodes: ["STOCK"] },
  },

  // delivery notes
  {
    path: "/delivery-notes",
    name: "InventoryNoteListePage",
    component: InventoryNoteListePage,
    meta: { requiresAuth: true, staffCodes: ["BON_LIVRAISON"] },
  },
  {
    path: "/add-delivery-note",
    name: "DeliveryAddNotePage",
    component: DeliveryAddNotePage,
    meta: { requiresAuth: true, staffCodes: ["BON_LIVRAISON"] },
  },
  {
    path: "/edit-delivery-note/:id/:refNote",
    name: "DeliveryEditNotePage",
    component: DeliveryEditNotePage,
    meta: { requiresAuth: true, staffCodes: ["BON_LIVRAISON"] },
  },
  {
    path: "/delivery-stock-notes",
    name: "InventoryStockNoteListePage",
    component: InventoryStockNoteListePage,
    meta: { requiresAuth: true, staffCodes: ["BON_LIVRAISON"] },
  },
  {
    path: "/add-delivery-stock-notes",
    name: "AddNoteBLStockPage",
    component: AddNoteBLStockPage,
    meta: { requiresAuth: true, staffCodes: ["BON_LIVRAISON"] },
  },
  {
    path: "/edit-delivery-stock/:id/:refNote",
    name: "EditNoteBLStockPage",
    component: EditNoteBLStockPage,
    meta: { requiresAuth: true, staffCodes: ["BON_LIVRAISON"] },
  },

  {
    path: "/logout",
    name: "LogoutPage",
    component: LogoutPage,
  },

  // return notes
  {
    path: "/return-client-liste",
    name: "ReturnListePage",
    component: ReturnListePage,
    meta: { requiresAuth: true, staffCodes: ["BON_LIVRAISON"] },
  },

  // invoices
  {
    path: "/invoices-liste",
    name: "InvoiceListPage",
    component: InvoiceListPage,
    meta: { requiresAuth: true, staffCodes: ["FACTURES"] },
  },

  // virements
  {
    path: "/virements-liste",
    name: "VirementListPage",
    component: VirementListPage,
    meta: { requiresAuth: true },
  },

  // settings
  {
    path: "/profile",
    name: "ProfilePage",
    component: ProfilePage,
    meta: { requiresAuth: true },
  },

  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: RegisterPage,
  },
  {
    path: "/complete-register/:id/:token",
    name: "CompleteRegisterPage",
    component: CompleteRegisterPage,
  },
  {
    path: "/documentation-api",
    name: "ApiPage",
    component: ApiPage,
  },
  {
    path: "/documents",
    name: "VerificationPage",
    component: VerificationPage,
  },
  {
    path: "/shopify",
    name: "ShopifyPage",
    component: ShopifyPage,
  },
  {
    path: "/sheets",
    name: "SheetsPage",
    component: SheetsPage,
  },
  {
    path: "/ColisConfirmed",
    name: "ColisConfirmedPage",
    component: ColisConfirmedPage,
  },
  {
    path: "/ColisErrones",
    name: "ColisErronesPage",
    component: ColisErronesPage,
  },
  {
    path: "/webhooks",
    name: "WebhookPage",
    component: WebhookPage,
  },

  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
